import { useState } from 'react'
import {
    RiText,
    RiImageLine,
    RiShapeLine,
    RiStackLine,
    RiLayoutLine,
    RiDownloadLine,
} from 'react-icons/ri'
import { TextPanel } from '@/components/editor/panels/TextPanel/TextPanel'
import { ImagePanel } from '@/components/editor/panels/ImagePanel/ImagePanel'
import { ShapePanel } from '@/components/editor/panels/ShapePanel/ShapePanel'
import { LayerPanel } from '@/components/editor/panels/LayerPanel/LayerPanel'
import { AlignmentPanel } from '@/components/editor/panels/AlignmentPanel/AlignmentPanel'
import { ExportPanel } from '@/components/editor/panels/ExportPanel/ExportPanel'
import { useIsMobile } from '@/hooks'
import styles from './EditorSidebar.module.css'

const tools = [
    { id: 'text', icon: RiText, label: 'Texto' },
    { id: 'image', icon: RiImageLine, label: 'Imagen' },
    { id: 'shapes', icon: RiShapeLine, label: 'Formas' },
    { id: 'align', icon: RiLayoutLine, label: 'Alinear' },
    { id: 'layers', icon: RiStackLine, label: 'Capas' },
    { id: 'export', icon: RiDownloadLine, label: 'Exportar' },
]

const panels: Record<string, React.ComponentType> = {
    text: TextPanel,
    image: ImagePanel,
    shapes: ShapePanel,
    align: AlignmentPanel,
    layers: LayerPanel,
    export: ExportPanel,
}

export function EditorSidebar() {
    const [activePanel, setActivePanel] = useState<string | null>(null)
    const isMobile = useIsMobile()

    const handleToolClick = (toolId: string) => {
        setActivePanel(activePanel === toolId ? null : toolId)
    }

    const ActivePanel = activePanel ? panels[activePanel] : null

    return (
        <>
            {isMobile && activePanel && (
                <div className={styles.backdrop} onClick={() => setActivePanel(null)} />
            )}
            <div className={styles.sidebar}>
                <div className={styles.toolBar}>
                    {tools.map((tool) => (
                        <button
                            key={tool.id}
                            className={`${styles.toolButton} ${activePanel === tool.id ? styles.active : ''}`}
                            onClick={() => handleToolClick(tool.id)}
                            title={tool.label}
                        >
                            <tool.icon />
                            <span className={styles.toolLabel}>{tool.label}</span>
                        </button>
                    ))}
                </div>
                {ActivePanel && (
                    <div className={styles.panel}>
                        <ActivePanel />
                    </div>
                )}
            </div>
        </>
    )
}
